export const CLASSIC_APP_ORIGIN =
  process.env.REACT_APP_CLASSIC_APP_ORIGIN || 'https://app.getupgraded.ca';

export const MARKETING_ORIGIN =
  process.env.REACT_APP_MARKETING_ORIGIN || 'https://www.getupgraded.ai';

export const CANONICAL_HOST = 'www.getupgraded.ai';

// Local dev serves both the classic app and the new marketing shell from one
// origin, so cross-origin app switching must be disabled there.
export function isLocalHost(host = typeof window !== 'undefined' ? window.location.hostname : '') {
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '[::1]' ||
    host.endsWith('.localhost')
  );
}

export function classicAppUrl(path = '/', search = '') {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const query = search && search.startsWith('?') ? search : search ? `?${search}` : '';
  const origin = isLocalHost() ? '' : CLASSIC_APP_ORIGIN;
  return `${origin}${normalized}${query}`;
}
